import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import apiV2 from '../../../services/apiV2';

export function UnitLiveInvitation({ assignment, section, attempt, owner, prepare }: {
  assignment: number; section: number; attempt: number; owner: number;
  prepare: () => Promise<{ revision: number } | null>;
}) {
  const [run, setRun] = useState<any>(null);
  const [error, setError] = useState('');
  const [pollError, setPollError] = useState('');
  const [joining, setJoining] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    let active = true;
    const poll = async () => {
      try {
        const { data } = await apiV2.get('/lesson-runs/my-active/', { params: { section_id: section } });
        if (active) { setRun(data && Number(data.section) === section && (data.delivery_phase !== 'studio' || data.pacing_mode === 'selective') ? data : null); setPollError(''); }
      } catch { if (active) { setRun(null); setPollError('Could not check live invitations. Keep working or ask your teacher.'); } }
    };
    void poll(); const interval = setInterval(poll, 5000);
    return () => { active = false; clearInterval(interval); };
  }, [section]);
  return <div className="space-y-2">
    {pollError && <p role="status">{pollError}</p>}
    {error && <p role="status">{error}</p>}
    {run && <div className="rounded-lg border border-brand p-3">
      <p>Your teacher has a live lesson for you. Your unit work will be saved before joining.</p>
      <button className="btn-primary" disabled={joining} onClick={async () => {
        setJoining(true); setError('');
        try {
          const saved = await prepare();
          if (!saved) { setError('Your draft is still saving or needs attention. Wait for confirmation, then try again.'); return; }
          const { data } = await apiV2.post(`/assignments/${assignment}/join-live/`, { run_id: run.id, attempt, expected_owner_id: owner, revision: saved.revision });
          navigate(data.href);
        } catch (e: any) { setError(e?.response?.data?.error || 'Could not join. Your unit work remains available.'); }
        finally { setJoining(false); }
      }}>Save work and join live lesson</button>
    </div>}
  </div>;
}

export function UnitLiveReturnLink() {
  const [params] = useSearchParams();
  const raw = params.get('unit_return');
  const id = raw && /^\d+$/.test(raw) ? Number(raw) : null;
  const [destination, setDestination] = useState<any>(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) return;
    let active = true;
    const poll = async () => {
      try { const { data } = await apiV2.get(`/unit-live-returns/${id}/`); if (active) { setDestination(data); setError(''); } }
      catch (e: any) { if (active) { setDestination(null); setError(e?.response?.data?.error || 'Return link unavailable.'); } }
    };
    void poll(); const interval = setInterval(poll, 3000);
    return () => { active = false; clearInterval(interval); };
  }, [id]);
  if (!id) return null;
  return <div className="rounded-lg border border-brand bg-surface p-4" role="status">
    {destination && <><p>Unit work: {destination.title}</p>
      {destination.released ? <button className="btn-primary" onClick={async () => {
        try { const { data } = await apiV2.post(`/unit-live-returns/${id}/`); navigate(data.href); }
        catch (e: any) { setError(e?.response?.data?.error || 'Could not return yet.'); }
      }}>Return to my saved unit work</button> : <p>Your work is saved. The return button becomes available when your teacher releases you.</p>}</>}
    {error && <><p>{error}</p><Link className="underline" to="/v2/student/units">Open my unit work</Link></>}
  </div>;
}
